import React, { useState } from 'react';
import { FaSyncAlt } from 'react-icons/fa';

// Small corner refresh icon. Pass an async onRefresh; the icon spins while
// it runs. Used next to every independently-fetchable data block so admins
// can re-pull fresh data without reloading the page.
const RefreshButton = ({ onRefresh, title = 'Refresh' }) => {
  const [busy, setBusy] = useState(false);

  const handleClick = async (e) => {
    e.stopPropagation();
    if (busy) return;
    setBusy(true);
    try {
      await onRefresh();
    } catch (err) {
      console.error('Refresh failed:', err);
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      className={`admin-refresh-btn ${busy ? 'admin-refresh-spinning' : ''}`}
      onClick={handleClick}
      title={title}
      aria-label={title}
      disabled={busy}
    >
      <FaSyncAlt size={12} />
    </button>
  );
};

export default RefreshButton;
